import { Trans } from "@lingui/react/macro";
import { setSelectedSites } from "@medoma/shared-employee/selectedSites";
import styles from "./SiteSelector.module.scss";
import { Heading } from "@medoma/components/Heading/Heading";
import type { ISite } from "@medoma/models/sites";

export const SiteSelector = ({
  sites,
  userId,
}: {
  sites: ISite[];
  userId: string;
}) => {
  return (
    <div className={styles.siteSelector}>
      <div className={styles.sites}>
        <Heading level="h1">
          <Trans>Välj enhet</Trans>
        </Heading>
        <ul>
          {sites.map((site) => (
            <li key={site.id}>
              <button
                onClick={() => setSelectedSites([site.id], userId)}
                className={styles.site}
              >
                {site.displayName}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
